import { render, staticRenderFns } from "./FormReviewSR.vue?vue&type=template&id=4dc58a61&scoped=true"
import script from "./FormReviewSR.vue?vue&type=script&lang=js"
export * from "./FormReviewSR.vue?vue&type=script&lang=js"
import style0 from "./FormReviewSR.vue?vue&type=style&index=0&id=4dc58a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc58a61",
  null
  
)

export default component.exports